
export const APP_TITLE = 'Kuali-Add-Edit';
export const BUILD_DATE = 'September 2023';
export const COPYRIGHT = '© 2023 -  Simon Fraser University';
export const VERSION = '1.0.0';
export const LEAVE_MSG = 'Are you sure you want to leave?';

export enum STATUS {
  READY,
  LOADING,
  COMPLETE,
}
export const FAKE_DELAY = 500;
export const DEBOUNCE_VALUE = 300;
export const TABLE_DEBOUNCE_VALUE = 1500;
export const TOAST_DELAY_VALUE = 5000;

export enum API_RESPONSE_STATUS {
  READY = '',
  SUCCESS = 'success',
  ERROR = 'danger',
}

export type API_RESPONSE = {
  message: string;
  statusLevel: API_RESPONSE_STATUS;
};

export const INIT_API_RESPONSE: API_RESPONSE = {
  message: '',
  statusLevel: API_RESPONSE_STATUS.READY,
};

export type Dict_Lookup<T> = {
  [key: string]: T;
};

export const DATE_TIME_FIELDS: Dict_Lookup<string> = {
};

export const DATE_FIELDS: Dict_Lookup<string> = {
};

export const INIT_SELECT_FIELDS: Dict_Lookup<string[] | number[]> = {
};
